import React, {FC} from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {IconButton} from '../../../../libs/shared/ui/src/components/buttons/iconButton';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {useSidePanelContext} from '../../inboxes/side/sidePanelContext';

/*
 * Props.
 */

interface SidePanelCloseButtonProps {
  className?: string;
  onClose?: () => void;
}

/*
 * Component.
 */

export const SidePanelCloseButton: FC<SidePanelCloseButtonProps> = (props) => {
  const theme = useUserTheme();
  const {onClose} = props;
  const {closeSidePanel} = useSidePanelContext();

  return (
    <IconButton
      iconName="close"
      interactionId="sidepanelheader-close-btn"
      label={<Trans id="sidepanelheader-close-button">Close</Trans>}
      onClick={() => {
        closeSidePanel();
        if (onClose) {
          onClose();
        }
      }}
      color={theme.greys.shade80}
      hoverColor={theme.greys.shade80}
      className={props.className}
    />
  );
};
